import { Component, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { FreeReducedMealAppService } from '../../../shared-modules/free-reduced-meal-app/free-reduced-meal-app.service';
import { FreeReducedMealAppStudentLunchStatus } from '../../../shared-modules/free-reduced-meal-app/models/free-reduced-meal-app-student-lunch-status.model';

@Component({
  selector: 'free-reduced-meal-app-student-status',
  templateUrl: './free-reduced-meal-app-student-status.component.html',
  styleUrls: ['./free-reduced-meal-app-student-status.component.css']
})
export class FreeReducedMealAppStudentStatusComponent implements OnInit {

  private _yearId: number;
  public get yearId(): number {
  return this._yearId;
  }
  @Input() public set yearId(value: number) {
    this._yearId = value;
    if (this.initialized) {
      this.getStatus();
    }
  }

  private familyId: number;
  students: FreeReducedMealAppStudentLunchStatus[];
  dataSource = new TylerMatTableDataSource();
  initialized = false;
  columnsToDisplay = ['Student', 'Status'];

  constructor(
    private freeReducedMealAppService: FreeReducedMealAppService
  ) { }

  ngOnInit(): void {
    if (this.freeReducedMealAppService.selectedFamily) {
      this.familyId = this.freeReducedMealAppService.selectedFamily.FamilyID;
      this.getStatus();
    }
  }

  getStatus() {
    this.initialized = true;
    if (this.familyId && this.yearId) {
      this.freeReducedMealAppService.getFRMAStudentStatus(this.familyId, this.yearId).pipe(take(1)).subscribe(students => {
        const visibleStudentIds = this.freeReducedMealAppService.selectedFamily.Students.filter(o => o.CanSee).map(o => o.Id);
        this.students = students;
        this.dataSource.data = this.students.filter(o => visibleStudentIds.includes(o.Id));
        if (this.students.find(o => o.Expires) != null) {
          this.columnsToDisplay = ['Student', 'Status', 'Expires'];
        }
        else {
          this.columnsToDisplay = ['Student', 'Status'];
        }
      });
    }
  }

  getStudentName(student: FreeReducedMealAppStudentLunchStatus): string {
    let studentName = student.FirstName + ' ' + student.LastName;
    if (student.Suffix && student.Suffix.trim()) {
      const firstTwoChars = student.Suffix.trim().substring(0,2);
      if (firstTwoChars.toLowerCase() == 'jr' || firstTwoChars.toLowerCase() == 'sr') {
        studentName +=  ', ' + student.Suffix;
      }
      else {
        studentName += ' ' + student.Suffix;
      }
    }
    return studentName;
  }

}
